React = require 'react'
t = require('views/internal/recup-with-helpers')('org_account')
track = require 'debug/track'
l = require 'lib/localize'

module.exports = class extends React.Component
  displayName: 'ExternalMembersDisabledComponent'

  render: t.renderable ->
    { externalMembersDisabled } = @props

    t.div '.setting-item-detail', ->
      t.div '.markeddown', ->
        t.p ->
          if externalMembersDisabled == undefined
            t.format 'let-team-admins-decide'
          else if externalMembersDisabled == false
            t.format 'anybody-can-be-added-to-boards-inside-teams'
          else
            t.format 'only-team-members-can-be-added-to-boards-inside-teams'



// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/dashboard/teams-settings/external-members-disabled-component.coffee